import React, { Component } from 'react';
import queryString from 'query-string';
import PropTypes from 'prop-types';

import { SCREEN_ID_CONNECT_BANK_ACCOUNT_FORM } from 'client/constants/screenIds';

import ListingActions from 'client/actions/Listing';
import PartnerActions from 'client/actions/Partner';
import NavigatorActions from 'client/actions/Navigator';

import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withLocationQuery from 'client/helpers/withLocationQuery';

import SrConnectBankAccountForm from 'client/components/SrConnectBankAccountForm/SrConnectBankAccountForm';

@withTransitionHook
@withScreenId(SCREEN_ID_CONNECT_BANK_ACCOUNT_FORM)
@withScrollToTop
@branch(({ match }) => {
  const cursors = {
    listing: ['listing'],
  };
  if (match.params.partnerId) {
    cursors.partner = ['partners', 'byId', match.params.partnerId];
  }
  return cursors;
})
@branch(({ partner, listing }) => {
  return !partner && listing?.partnerId ? { partner: ['partners', 'byId', listing.partnerId] } : {};
})
@withLocationQuery
class ConnectBankAccountFormPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Connect Bank Account | Sunroom Rentals',
  });

  static fetchData(match, inject) {
    const listingId = parseInt(match.params.listingId, 10);
    const partnerId = parseInt(match.params.partnerId, 10);

    if (listingId) {
      return ListingActions.getById(inject, listingId).then((listing) => {
        if (listing.partnerId) {
          return PartnerActions.getById(inject, {
            partnerId: listing.partnerId,
          });
        }
      });
    }
    if (partnerId) {
      return PartnerActions.getById(inject, {
        partnerId: partnerId,
      });
    }
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    locationQuery: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    partner: PropTypes.object,
  };

  _getConnectBankBackButtonUrl = () => {
    const {
      partner,
      match: {
        params: { listingId },
      },
    } = this.props;

    return listingId
      ? `/connect-bank/listing/${listingId}/start`
      : `/partner/${partner.slug}/settings/banks`;
  };

  _onBack = () => {
    const { dispatch } = this.props;
    dispatch(NavigatorActions.goBack, {
      defaultTo: this._getConnectBankBackButtonUrl(),
    });
  };

  _onSubmit = () => {
    const { partner, locationQuery, dispatch, match } = this.props;
    dispatch(PartnerActions.loadPartnerBySlug, {
      slug: partner.slug,
      forceRefresh: true,
    });

    let redirectTo = `/partner/${partner.slug}/settings/banks`;

    if (match.params.listingId) {
      redirectTo = `/partner/${partner.slug}/listing/${match.params.listingId}`;
    }

    if (Object.keys(locationQuery).length) {
      redirectTo += `?${queryString.stringify(locationQuery)}`;
    }

    global.location.href = redirectTo;
  };

  render() {
    const {
      dispatch,
      match: {
        params: { listingId: listingIdStr, partnerId: partnerIdStr },
      },
    } = this.props;

    const listingId = parseInt(listingIdStr, 10) || null;
    const partnerId = parseInt(partnerIdStr, 10) || null;
    return (
      <SrConnectBankAccountForm
        dispatch={dispatch}
        listingId={listingId}
        partnerId={partnerId}
        onBack={this._onBack}
        onSubmit={this._onSubmit}
      />
    );
  }
}

ConnectBankAccountFormPage.displayName = 'ConnectBankAccountFormPage';

export default ConnectBankAccountFormPage;
